import { EditRegisterDescriptionDialog } from "./edit-register-description-dialog"
import { RegisterMetadataMenuItem } from "../register-actions/register-metadata-menu-item"

export function EditRegisterDescriptionMenuItem() {
    return (
        <RegisterMetadataMenuItem
            icon="mdi:text-box-edit-outline"
            label="Edit Description"
            dataCy="register-row-menu-edit-description"
            DialogComponent={EditRegisterDescriptionDialog}
            errorMessage="Failed to edit asset register description"
            getUpdateValues={getUpdateValues}
        />
    )

    function getUpdateValues(updated) {
        return { description: updated.description }
    }
}
